import { render, staticRenderFns } from "./GridConsultant.vue?vue&type=template&id=5985e5a0&"
import script from "./GridConsultant.vue?vue&type=script&lang=js&"
export * from "./GridConsultant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports